import { useAppSelector } from 'modules/Editor/store';
import { selectPageOrder } from 'modules/Editor/store/infographSelector';
import { selectActivePage } from 'modules/Editor/store/pageSelector';
import { AddLinkButton } from 'modules/common/components/Link';
import { MouseEvent } from 'react';
import { checkIsValidLink } from 'widgets/sdk/widgetSdk.helpers';

interface LinkMenuProps {
  isActive: boolean;
  value?: string;
  text?: string;
  // Null is when the alert is dismissed by clicking outside
  // Or when an invalid url is entered
  onChange: (url: string | null) => void;
  onMouseDown?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const LinkMenu = ({ isActive, value, text, onChange, onMouseDown }: LinkMenuProps) => {
  const pageOrder = useAppSelector(selectPageOrder);
  const activePage = useAppSelector(selectActivePage);
  const isValidLink = checkIsValidLink(value);

  return (
    <AddLinkButton
      value={value}
      isActive={isActive && isValidLink}
      onChange={onChange}
      onMouseDown={onMouseDown}
      text={text}
      pageOrder={pageOrder}
      activePage={activePage}
    />
  );
};
